/**
 * Полоса истории раундов.
 *
 * Игроки читают по ней «серии» и на основе этого выбирают ставку, поэтому
 * полоса должна быть честной: показываем все последние раунды подряд, без
 * фильтрации и без переупорядочивания.
 */

import { multiplierToNumber } from "@koshkodrop/shared";

import { haptic } from "../../lib/telegram";
import { useCrash } from "../../store/crash";

interface Props {
  onSelect?: (sequence: number) => void;
}

export function HistoryStrip({ onSelect }: Props) {
  const history = useCrash((state) => state.history);

  if (history.length === 0) {
    return <div className="h-9" />;
  }

  return (
    <div className="no-select -mx-4 overflow-x-auto px-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      <div className="flex gap-2">
        {history.map((item) => {
          const value = multiplierToNumber(item.crashPoint);
          const tone =
            value >= 10
              ? "bg-paws-500/20 text-paws-300"
              : value >= 2
                ? "bg-win-500/15 text-win-400"
                : "bg-lose-500/15 text-lose-400";

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => {
                haptic.select();
                onSelect?.(item.sequence);
              }}
              className={`tabular shrink-0 rounded-xl px-2.5 py-1.5 text-xs font-bold ${tone}`}
            >
              {value.toFixed(2)}x
            </button>
          );
        })}
      </div>
    </div>
  );
}
